import React from 'react';

const ContactButton = ({
    text = "Contact Me",
    className = "",
    inquiryType = "General Inquiry",
    prefilledData = {},
    onClick
}) => {
    return (
        <button
            onClick={() => onClick(inquiryType, prefilledData)}
            className={`bg-sage-600 text-white px-8 py-4 rounded-lg hover:bg-sage-700 transition-colors duration-300 font-medium text-lg shadow-lg hover:shadow-xl transform hover:-translate-y-1 ${className}`}
        >
            {text}
        </button>
    );
};

export default ContactButton;